import { FIXED_LABELS, HOUSE_LABEL, OTHER_LABEL, WORK_LABEL } from "./constants";

const getInitialType = (value: string | undefined) => {
  if (!value) return undefined;
  if (value === HOUSE_LABEL) return HOUSE_LABEL;
  if (value === WORK_LABEL) return WORK_LABEL;
  return OTHER_LABEL;
};

const getInitialCustomLabel = (value: string | undefined) => {
  if (!value || FIXED_LABELS.includes(value)) return '';
  return value;
};

export {getInitialType, getInitialCustomLabel};
